// The onGuard score in words (product owner, 2026-10-22): a percentage ("41%") everywhere it appears, the same way
// the Microsoft Secure Score reads, so the two never look like different scales. A change between two scores stays
// in points ("up 3 points"): a percent of a percent would mislead.

/** The unit shown beside a big onGuard score number. */
export const SCORE_UNIT = '%';

const finite = (n) => typeof n === 'number' && Number.isFinite(n);

/** "41%" for a finite score, else the fallback ("--" by default). Never a zero for a missing score. */
export function formatScore(score, fallback = '--') {
  return finite(score) ? `${score}%` : fallback;
}

/**
 * The whole-number percent a KPI tile shows (product owner, 2026-10-23): 58.42 reads 58 on every page, so Overview
 * and Security never disagree. The precise points stay in the caption ("711.5 of 1218 points"). null when missing.
 */
export function scorePercent(value) {
  return finite(value) ? Math.round(value) : null;
}

/** "58%" for a KPI percent (whole number), else the fallback ("--" by default). */
export function formatPercent(value, fallback = '--') {
  const n = scorePercent(value);
  return n == null ? fallback : `${n}%`;
}

/** "711.5 of 1218 points" for a Microsoft Secure Score snapshot, or null without a current score. */
export function secureScorePoints(ms) {
  if (!ms || !finite(ms.currentScore)) return null;
  return `${ms.currentScore.toFixed(1)} of ${ms.maxScore} points`;
}

/** "3 points" or "1 point" for a score change (its absolute value). */
export function formatPoints(delta) {
  const n = Math.abs(Number(delta) || 0);
  return `${n} ${n === 1 ? 'point' : 'points'}`;
}
